import { useState, useEffect } from 'react';
import Logo from '../../../components/feature/Logo';

interface HeaderProps {
  onSubmitCampClick: () => void;
}

export default function Header({ onSubmitCampClick }: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="cursor-pointer">
            <Logo variant="horizontal" scrolled={isScrolled} />
          </a>

          <nav className="hidden md:flex items-center gap-6">
            <a href="#home" className={`text-sm font-semibold hover:text-[#E91E8C] transition-colors whitespace-nowrap ${isScrolled ? 'text-[#3D1A6E]' : 'text-white'}`}>
              Home
            </a>
            <a href="#browse" className={`text-sm font-semibold hover:text-[#E91E8C] transition-colors whitespace-nowrap ${isScrolled ? 'text-[#3D1A6E]' : 'text-white'}`}>
              Browse Camps
            </a>
            <button
              onClick={onSubmitCampClick}
              className="bg-[#E91E8C] text-white px-6 py-2.5 rounded-full font-bold hover:bg-[#D91A7E] transition-all text-sm whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-105"
            >
              Submit Your Camp
            </button>
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${isScrolled ? 'text-[#3D1A6E]' : 'text-white'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-3 bg-white rounded-2xl p-5 shadow-xl border border-gray-100">
            <a href="#home" className="text-sm font-semibold text-[#3D1A6E] hover:text-[#E91E8C] transition-colors py-2 whitespace-nowrap">
              Home
            </a>
            <a href="#browse" className="text-sm font-semibold text-[#3D1A6E] hover:text-[#E91E8C] transition-colors py-2 whitespace-nowrap">
              Browse Camps
            </a>
            <button
              onClick={onSubmitCampClick}
              className="bg-[#E91E8C] text-white px-6 py-2.5 rounded-full font-bold hover:bg-[#D91A7E] transition-all text-sm whitespace-nowrap shadow-lg"
            >
              Submit Your Camp
            </button>
          </nav>
        )}
      </div>
    </header>
  );
}
